import { RankCheckStatus } from '../Modules/Slot/Model/Slot';

/** 비개발자용 순위 조회 상태 표시 */
export function getRankCheckStatusLabel(status?: RankCheckStatus | null): string {
  switch (status) {
    case 'idle':
    case 'pending':
      return '대기중';
    case 'running':
      return '확인 중';
    case 'complete':
      return '완료';
    case 'failed':
      return '실패';
    default:
      return '-';
  }
}

export function getRankCheckStatusColor(status?: RankCheckStatus | null): string {
  switch (status) {
    case 'idle':
    case 'pending':
      return 'default';
    case 'running':
      return 'processing';
    case 'complete':
      return 'success';
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
}

export function isRankCheckWaiting(status?: RankCheckStatus | null): boolean {
  return status === 'idle' || status === 'pending';
}

export function isRankCheckInProgress(status?: RankCheckStatus | null): boolean {
  return status === 'pending' || status === 'running';
}

export function isRankCheckTerminal(status?: RankCheckStatus | null): boolean {
  return status === 'complete' || status === 'failed';
}
